export const ButtonsTab = ({ onDownloadPdf, onClickUploadActivities, errors }: { onDownloadPdf: any, onClickUploadActivities: any, errors: any }) => {


    interface DownloadCardProps {
        id: string,
        title: string;
        icon: string;
        description: string;
        onClickAction: any;
        alert?: string;
        disableIfErrors?: boolean;
        disableMessage?: string;
        disable?: boolean;
    }

    const cards: DownloadCardProps[] = [
        {
            id: '1',
            title: 'Cargar Actividades',
            icon: '/assets/icons/upload_icon.svg',
            description: 'Por esta via se podra subir las actividades para ser consolidadas',
            // alert: 'Recuerda validar los errores antes de continuar',
            onClickAction: onClickUploadActivities,
            disableIfErrors: true
        },
        {
            id: '2',
            title: 'Reportes Cartas',
            icon: '/assets/icons/field-report.svg',
            description: 'Estos son los archivos de carta en formato jpg',
            alert: 'Recuerda respaldar esta información pues nose guardara en ninguna DB',
            onClickAction: onDownloadPdf
        }
    ]

    const DownloadCard = (props: DownloadCardProps) => {


        return (
            <div className={`card_container ${props.disable ? 'disabled_card' : ''}`}
                onClick={() => !props.disable && props?.onClickAction()}>
                <img src={props.disable ? '/assets/icons/dissable-upload.svg' : props.icon} width={60} height={60} alt='' />
                <div className={`card_container__title ${props.disable && 'disabled_card'}`} > {props.title} </div>
                <div className='card_container__description'> {props.description} </div>
                {props.disable && (
                    <div className='card_container__disabledSection'>
                        <img src="/assets/icons/error.svg" width={20} height={20} alt='' />
                        {props.disableMessage}
                    </div>
                )}
                {props.alert && (
                    <div className='card_container__alertSection'>
                        <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
                        {props.alert}
                    </div>
                )}

            </div>
        )
    }


    return (
        <div className='upload_container'>
            <div className='upload_container_cards_section'>
                {cards.map((card, i) => {

                    let disable = false

                    if (card.disableIfErrors) {
                        Object.keys(errors).forEach((key) => {
                            if (errors[key].filter((e: any) => e.type === 'error').length > 0) {
                                disable = true
                            }
                        })
                    }

                    return (
                        <DownloadCard
                            key={i}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                            alert={card.alert}
                            id={card.id}
                            onClickAction={card.onClickAction}
                            disable={disable}
                            disableMessage="Existen errores en los archivos que son necesarior resolver"
                        />
                    )
                }
                )}
            </div>
        </div>
    )
}